import { render, staticRenderFns } from "./CallUpdateProjectTimeSettings.vue?vue&type=template&id=f3368964"
import script from "./CallUpdateProjectTimeSettings.vue?vue&type=script&lang=js"
export * from "./CallUpdateProjectTimeSettings.vue?vue&type=script&lang=js"
import style0 from "./CallUpdateProjectTimeSettings.vue?vue&type=style&index=0&id=f3368964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports